import { render, staticRenderFns } from "./newsdetail.vue?vue&type=template&id=75bee791&"
import script from "./newsdetail.vue?vue&type=script&lang=js&"
export * from "./newsdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports